<template>
	{{ $t('home.header') }}
</template>

<script>
// import { DatePicker } from 'ant-design-vue';

export default {
	components: {
	},
}
</script>
